import React from 'react';
import { Instagram, Youtube, MessageCircle, Send } from 'lucide-react';
export function Footer() {
  return <footer className="bg-garage-bg border-t border-garage-border pt-16 pb-8" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-49">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-50">
            <h3 className="text-2xl font-display font-bold text-garage-text mb-4" data-id="element-51">
              DEAD PEDAL <span className="text-garage-accent" data-id="element-52">GARAGE</span>
            </h3>
            <p className="text-garage-muted text-sm leading-relaxed mb-6" data-id="element-53">
              A garage without walls. Built by enthusiasts, for enthusiasts.
              Preserving car culture one build at a time.
            </p>
            <div className="flex gap-4" data-id="element-54">
              <a href="#" className="text-garage-muted hover:text-garage-accent transition-colors" data-id="element-55">
                <Instagram className="w-5 h-5" data-id="element-56" />
              </a>
              <a href="#" className="text-garage-muted hover:text-garage-accent transition-colors" data-id="element-57">
                <Youtube className="w-5 h-5" data-id="element-58" />
              </a>
              <a href="#" className="text-garage-muted hover:text-garage-accent transition-colors" data-id="element-59">
                <MessageCircle className="w-5 h-5" data-id="element-60" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-61">
            <h4 className="font-display font-bold text-garage-text mb-6 tracking-wider" data-id="element-62">
              COMMUNITY
            </h4>
            <ul className="space-y-3 text-sm text-garage-muted" data-id="element-63">
              <li data-id="element-64">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-65">
                  About Us
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-67">
                  Featured Builds
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-69">
                  Events
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-71">
                  Merch
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-72">
            <h4 className="font-display font-bold text-garage-text mb-6 tracking-wider" data-id="element-73">
              RESOURCES
            </h4>
            <ul className="space-y-3 text-sm text-garage-muted" data-id="element-74">
              <li data-id="element-75">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-76">
                  Knowledge Base
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-78">
                  Parts Swap
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-80">
                  Mentorship
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-garage-accent transition-colors" data-id="element-82">
                  Support
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-83">
            <h4 className="font-display font-bold text-garage-text mb-6 tracking-wider" data-id="element-84">
              STAY IN THE LOOP
            </h4>
            <p className="text-xs text-garage-muted mb-4" data-id="element-85">
              Get the latest builds and event updates straight to your inbox.
            </p>
            <div className="flex gap-2" data-id="element-86">
              <input type="email" placeholder="Enter your email" className="bg-garage-surface border border-garage-border text-garage-text px-4 py-2 text-sm w-full focus:outline-none focus:border-garage-accent transition-colors placeholder:text-garage-muted/50" data-id="element-87" />
              <button className="bg-garage-accent hover:bg-garage-accent-hover text-black p-2 transition-colors" data-id="element-88">
                <Send className="w-4 h-4" data-id="element-89" />
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-garage-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-90">
          <p className="text-xs text-garage-muted" data-id="element-91">
            © 2024 Dead Pedal Garage. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-garage-muted" data-id="element-92">
            <a href="#" className="hover:text-garage-text transition-colors" data-id="element-93">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-garage-text transition-colors" data-id="element-94">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}